/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div class="item-div">
    <div class="detail">
      <div class="item">
        <img src="../../resource/img/yue.png" @click="goTotal()"/>
        <span>累计领取金额</span>
        <span>{{ money }}元</span>
      </div>
      <div class="item">
        <img src="../../resource/img/leiji.png"/>
        <span>当前余额</span>
        <span>{{ totalMoney }}元</span>
      </div>
    </div>
    <div class="paybtn" @click="goWithdraw()">提现</div>
  </div>
</template>

<script>
export default {
  name: 'MerUnionCapitalDetail',
  data () {
    return {
      title: '我的钱包',
      totalMoney: 0,
      money: 0,
      queryData: {}
    }
  },
  created () {
    this.$common.changetitle(this.title)
    this.queryData = this.$route.query
  },
  mounted () {
    this.getMoney()
  },
  methods: {
    getMoney () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/extend-money',
        data: {
          uid: this.queryData.uid,
          merId: this.queryData.merId
        },
        login: false
      }).then(res => {
        this.totalMoney = res.data || 0
      })
      this.$api.post({
        url: '/merchant/api/activity/spread-list/user/sum/money',
        data: {
          fansid: this.queryData.fansid,
          activityId: this.queryData.activityId,
          activityType: 1
        },
        login: false
      }).then(res => {
        this.money = res.data || 0
      })
    },
    goWithdraw () {
      if (this.totalMoney > 0) {
        this.$router.push({
          path: '/MerUnionConfirmeAmount',
          query: {
            merId: this.queryData.merId,
            activityId: this.queryData.activityId,
            storeId: this.queryData.storeId,
            fansid: this.queryData.fansid,
            uid: this.queryData.uid
          }
        })
      } else {
        alert('当前余额为0')
      }
    },
    goTotal () {
      if (this.money > 0) {
        this.$router.push({
          path: '/MerTokerLjje',
          query: {
            activityType: 1,
            merId: this.queryData.merId,
            activityId: this.queryData.activityId,
            storeId: this.queryData.storeId,
            fansid: this.queryData.fansid,
            uid: this.queryData.uid
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.item-div {
  margin-top: 50px;
  background: #ffffff;
}

.item-div .detail {
  width: 90%;
  height: 150px;
  margin-left: 5%;
  background-color: #209ae0;
  border-radius: 30px;
  margin-top: 70px;
}

.item-div .detail .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.paybtn {
  width: 70%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #fff;
  background-color: #209ae0;
  margin-top: 40px;
  border-radius: 15px;
  margin-left: 15%;
  font-size: 15px;
}

.detail > div {
  width: 50%;
  height: 100%;
  float: left;
  text-align: center;
  color: #fff;
  font-size: 15px;
}

.detail > div > img {
  width: 45px;
  height: 45px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerUnionCapitalDetail.vue